import { gql, useMutation } from '@apollo/client';
import { GET_DPO_AUDIT_REPORT_HISTORY } from './useDpoAuditReportHistoryQuery';

const CREATE_DPO_AUDIT_REPORT_HISTORY = gql`
  mutation CreateDpoAuditReportHistory($companyId: String!, $htmlContent: String!) {
    createDpoAuditReportHistory(companyId: $companyId, htmlContent: $htmlContent) {
      id
      createdAt
      companyId
      htmlContent
    }
  }
`;

export interface CreateDpoAuditReportHistoryResult {
  createDpoAuditReportHistory: {
    id: string;
    createdAt: string;
    companyId: string;
    htmlContent: string;
  };
}

export interface CreateDpoAuditReportHistoryInput {
  companyId: string;
  htmlContent: string;
}

export function useCreateDpoAuditReportHistoryMutation(companyId: string) {
  return useMutation<CreateDpoAuditReportHistoryResult, CreateDpoAuditReportHistoryInput>(
    CREATE_DPO_AUDIT_REPORT_HISTORY,
    {
      refetchQueries: [{ query: GET_DPO_AUDIT_REPORT_HISTORY, variables: { companyId } }],
    }
  );
}
